import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const rawMsg = err.response?.data?.message || err.response?.data?.error;
	if (rawMsg) {
		// Format: "ERR_CODE:Human readable message" — show the human part
		const colonIdx = rawMsg.indexOf(":");
		const errorKey = colonIdx > -1 ? rawMsg.slice(0, colonIdx) : rawMsg;
		const humanMsg = colonIdx > -1 ? rawMsg.slice(colonIdx + 1).trim() : rawMsg;

		if (i18n.exists(`backendErrors.${errorKey}`)) {
			toast.error(i18n.t(`backendErrors.${errorKey}`), {
				toastId: errorKey,
			});
		} else {
			toast.error(humanMsg || errorKey, {
				toastId: errorKey,
			});
		}
	} else if (err.code === "ERR_NETWORK" || err.message === "Network Error") {
		toast.error("Sin conexión al servidor. Verificá tu conexión.", {
			toastId: "network_error",
		});
	} else if (err.response?.status === 401) {
		toast.error("Sesión expirada. Por favor, iniciá sesión nuevamente.", {
			toastId: "session_expired",
		});
	} else if (err.response?.status === 403) {
		toast.error("No tenés permiso para realizar esta acción.", {
			toastId: "forbidden",
		});
	} else if (err.response?.status >= 500) {
		toast.error("Error interno del servidor. Intentá nuevamente.", {
			toastId: "server_error",
		});
	} else {
		toast.error("Ocurrió un error. Intentá nuevamente.", {
			toastId: "generic_error",
		});
	}
};

export default toastError;
